





















































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import menu from "@/store/modules/ApplicationModule/data/menu";

// Vue components
import AppPage from "@/components/AppPage.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import OfflineInstallationsMainTable from "./OfflineInstallationsMainTable.vue";
import AgentOfflineInstallationsMainTable from "./AgentOfflineInstallationsMainTable.vue";
import InstallationsWithoutLicensesMainTable from "./InstallationsWithoutLicensesMainTable.vue";
import FoldersPanels from "./FoldersPanels.vue";
import UsersPanels from "./UsersPanels.vue";

//Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { dataTableItemsPerPage } from "@/utility/Constants";
import { GetAgentOfflineInstallationsCommand, GetAgentOfflineInstallationsReqData } from "@/model/communication/platformMaintenance/GetAgentOfflineInstallationsCommand";
import { GetOfflineInstallationsCommand, GetOfflineInstallationsReqData } from "@/model/communication/platformMaintenance/GetOfflineInstallationsCommand";
import { GetOfflineInstallationsResData } from "@/model/communication/platformMaintenance/GetOfflineInstallationsResData";
import { GetInstallationsWithoutLicensesCommand } from "@/model/communication/platformMaintenance/GetInstallationsWithoutLicensesCommand";
import { GetInstallationsWithoutLicensesResData } from "@/model/communication/platformMaintenance/GetInstallationsWithoutLicensesResData";
import { GetAgentOfflineInstallationsResData } from "@/model/communication/platformMaintenance/GetAgentOfflineInstallationsResData";
import { GetInstallationsEnabledModulesReqData } from "@/model/communication/license/GetInstallationsEnabledModulesReqData";
import { DeleteInstallationsRequestDownloadCommand } from "@/model/communication/authActions/DeleteInstallationsRequestDownloadCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import ScheduleEmailCard from "./ScheduleEmailCard.vue";

export default Vue.extend({
    components: {
        AppPage,
        DeviceModelChip,
        OfflineInstallationsMainTable,
        AgentOfflineInstallationsMainTable,
        InstallationsWithoutLicensesMainTable,
        FoldersPanels,
        UsersPanels,
        ScheduleEmailCard,
    },
    data() {
        return {
            loading: false,
            loadingAgent: false,
            offlineInstallations: [],
            agentOfflineInstallations: [],
            totalInstallationCount: 0,
            agentTotalInstallationCount: 0,
            paginatedTotalItems: 0,
            agentPaginatedTotalItems: 0,
            reqData: new GetOfflineInstallationsReqData(),
            reqDataAgent: new GetAgentOfflineInstallationsReqData(),
            currentPaginationOptions: {
                page: 1,
                itemsPerPage: dataTableItemsPerPage[0],
                sortBy: [],
                sortDesc: [],
            },
            currentPaginationOptionsAgent: {
                page: 1,
                itemsPerPage: dataTableItemsPerPage[0],
                sortBy: [],
                sortDesc: [],
            },
            firstTime: true,
            firstTimeAgent: true,
            noLicenseTotalCount: 0,
            noLicensePaginatedTotalItems: 0,
            noLicenseInstallations: [],
            loadingLicense: false,
            firstTimeLicense: true,
            currentPaginationOptionsLicense: {
                page: 1,
                itemsPerPage: dataTableItemsPerPage[0],
                sortBy: [],
                sortDesc: [],
            },
            reqDataLicense: new GetInstallationsEnabledModulesReqData(),
            deleteLoading: false,
            offlineDays: `...${this.$t("common.loading").toString().toLowerCase()}...`,
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege", "userTimeFormat"]),
        menuEntry() {
            return menu.find((m) => m.name == "Tools").children.find((c) => c.name == "PlatformMaintenance");
        },
        offlineInstallationTextColor() {
            if (this.totalInstallationCount == 0) return "success--text";
            else if (this.totalInstallationCount < 10) return "warning--text";
            else return "error--text";
        },
        agentOfflineInstallationTextColor() {
            if (this.agentTotalInstallationCount == 0) return "success--text";
            else if (this.agentTotalInstallationCount < 10) return "warning--text";
            else return "error--text";
        },
        noLicenseInstallationTextColor() {
            if (this.noLicenseTotalCount == 0) return "success--text";
            else if (this.noLicenseTotalCount < 10) return "warning--text";
            else return "error--text";
        },
        offlineInstallationIcon() {
            if (this.totalInstallationCount == 0) return "thumbs-up";
            else if (this.totalInstallationCount < 10) return "exclamation-circle";
            else return "exclamation-triangle";
        },
        agentOfflineInstallationIcon() {
            if (this.agentTotalInstallationCount == 0) return "thumbs-up";
            else if (this.agentTotalInstallationCount < 10) return "exclamation-circle";
            else return "exclamation-triangle";
        },
        noLicenseInstallationIcon() {
            if (this.noLicenseTotalCount == 0) return "thumbs-up";
            else if (this.noLicenseTotalCount < 10) return "exclamation-circle";
            else return "exclamation-triangle";
        },
        licenseEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.DeviceLicenseManagement);
        },
        statusManagementEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.StatusManagement);
        },
        foldersEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.DevicesManagement);
        },
        usersEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.UsersManagement);
        },
    },
    methods: {
        async sendRequest(request) {
            try {
                this.loading = true;

                let response: GetOfflineInstallationsResData = await new GetOfflineInstallationsCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.offlineInstallations = response.installations;
                    this.totalInstallationCount = response.totalInstallationsCount;
                    this.paginatedTotalItems = response.paginatedTotalItems;
                    this.offlineDays = response.offlineDays;
                }
            } catch (e) {
                console.log("Something went wrong sending GetOfflineInstallations request ", e);
            }
            this.loading = false;
            this.firstTime = false;
        },
        async sendRequestAgent(request) {
            try {
                this.loadingAgent = true;

                let response: GetAgentOfflineInstallationsResData = await new GetAgentOfflineInstallationsCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.agentOfflineInstallations = response.agentOfflineInstallation;
                    this.agentPaginatedTotalItems = response.paginatedTotalItems;
                    this.agentTotalInstallationCount = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending GetAgentOfflineInstallations request ", e);
            }
            this.loadingAgent = false;
            this.firstTimeAgent = false;
        },
        async sendRequestLicense(request) {
            try {
                this.loadingLicense = true;

                let response: GetInstallationsWithoutLicensesResData = await new GetInstallationsWithoutLicensesCommand(request).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.noLicenseInstallations = response.installations;
                    this.noLicensePaginatedTotalItems = response.paginatedTotalItems;
                    this.noLicenseTotalCount = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsWithoutLicenses request ", e);
            }
            this.loadingLicense = false;
            this.firstTimeLicense = false;
        },

        onOptionsChanged(newOptions, type) {
            let paginatedOptions;
            let newReqData;
            if (type == "agent") {
                newReqData = { ...this.reqDataAgent };
                this.currentPaginationOptionsAgent = newOptions;
                paginatedOptions = this.currentPaginationOptionsAgent;
            } else if (type == "caos") {
                newReqData = { ...this.reqData };
                this.currentPaginationOptions = newOptions;
                paginatedOptions = this.currentPaginationOptions;
            } else if (type == "license") {
                newReqData = { ...this.reqDataLicense };
                this.currentPaginationOptionsLicense = newOptions;
                paginatedOptions = this.currentPaginationOptionsLicense;
            }

            newReqData.offset = (paginatedOptions.page - 1) * paginatedOptions.itemsPerPage;
            newReqData.queryLimit = paginatedOptions.itemsPerPage;
            newReqData.orderBy = paginatedOptions.sortBy;
            newReqData.orderByDescending = paginatedOptions.sortDesc;

            if (type == "agent") this.sendRequestAgent(newReqData);
            else if (type == "caos") this.sendRequest(newReqData);
            else if (type == "license") this.sendRequestLicense(newReqData);
        },

        onFiltersChanged(filters, type) {
            let newReqData;
            if (type == "caos") newReqData = { ...this.reqData };
            else if (type == "license") newReqData = { ...this.reqDataLicense };

            newReqData.offset = 0;

            filters.forEach((filter) => {
                newReqData[filter.filterKey] = filter.currentSelections;
            });
            if (type == "caos") {
                this.$refs.mainTable.backToTheFirst();
                this.sendRequest(newReqData);
            } else if (type == "license") {
                this.$refs.mainTableLicense.backToTheFirst();
                this.sendRequestLicense(newReqData);
            }
        },
        onSearchInstallation(textSearch, type) {
            if (type == "agent") {
                this.reqDataAgent.installationPrefix = textSearch;
                this.sendRequestAgent(this.reqDataAgent);
            } else if (type == "caos") {
                this.reqData.installationPrefix = textSearch;
                this.sendRequest(this.reqData);
            } else if (type == "license") {
                this.reqDataLicense.installationPrefix = textSearch;
                this.sendRequestLicense(this.reqDataLicense);
            }
        },
        onDelete(installations) {
            this.deleteInstallationsRequestDownload(installations);
        },
        async deleteInstallationsRequestDownload(installations) {
            this.deleteLoading = true;
            try {
                const res = await new DeleteInstallationsRequestDownloadCommand(installations).execute();

                if (res.status == 200) {
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }
            } catch (e) {
                console.log("Something went wrong during AuthActionRequestDownloadCommand execution: ", e);
            }
            this.deleteLoading = false;
        },
    },
});
